import adminAxios from "@/shared/api/adminAxiosInstance";

// Удаление зала
export const deleteRoom = (id) => {
    return adminAxios.delete(`/admin/game-rooms/${id}`);
};

export const getRoomsDropdown = (params) => {
    return adminAxios.get('/admin/game-rooms/free', { params });
};


// Получение списка залов с пагинацией и фильтрацией
export const getRooms = (params, isActive='') => {
    // Пример params: { page: 0, size: 10, isActive: true }
    return adminAxios.get(`/admin/game-rooms${isActive}`, { params });
};

// Получение одного зала по id
export const getRoomById = (id) => {
    return adminAxios.get(`/admin/game-rooms/${id}`);
};

// Создание нового зала
export const createRoom = (data) => {
    // Пример data: { name: "Желтый зал", isActive: true }
    return adminAxios.post("/admin/game-rooms", data);
};

// Обновление существующего зала
export const updateRoom = (id, data) => {
    // Пример data: { name: "Зеленый зал", isActive: false }
    return adminAxios.put(`/admin/game-rooms/${id}`, data);
};

// Получить все системы
export const getSystems = (params) => {
    return adminAxios.get('/admin/game-systems', { params });
};

// Обновить систему
export const updateSystem = (id, data) => {
    return adminAxios.put(`/admin/game-systems/${id}`, data);
};

// Создать систему
export const createSystem = (data) => {
    return adminAxios.post('/admin/game-systems', data);
};

// Удалить систему
export const deleteSystem = (id) => {
    return adminAxios.delete(`/admin/game-systems/${id}`);
};

export const getGames = (params) => {
    return adminAxios.get('/admin/catalog-cards', { params });
};

// 🔍 Поиск игр по названию (асинхронно)
export const searchCatalogCards = (query) =>
    adminAxios.get(`/admin/catalog-cards/search`, { params: { query } });

export const getActiveGames = () => {
    return adminAxios.get(`/admin/catalog-cards?isActive=true`);
}

export const updateGame = (id, formData) => {
    return adminAxios.put(`/admin/catalog-cards/${id}`, formData);
};

export const toggleGameActive = (gameId) =>
    adminAxios.put(`/admin/catalog-cards/${gameId}/active`);

export const deleteGame = (id) => {
    return adminAxios.delete(`/admin/catalog-cards/${id}`);
};

export const createGame = (formData) => {
    return adminAxios.post('/admin/catalog-cards', formData);
};

export const getGameById = (id) => {
    return adminAxios.get(`/admin/catalog-cards/${id}`);
};





// Получить всё расписание
export const getSchedules = (params) => {
    return adminAxios.get('/admin/game-card-schedules', { params });
};

// Получить конкретное расписание по ID
export const getScheduleById = (id) => {
    return adminAxios.get(`/admin/game-card-schedules/${id}`);
};

// Создать запись расписания
export const createSchedule = (data) => {
    return adminAxios.post('/admin/game-card-schedules', data);
};

// Обновить расписание
export const updateSchedule = (id, data) => {
    return adminAxios.put(`/admin/game-card-schedules/${id}`, data);
};

// Удалить расписание
export const deleteSchedule = (id) => {
    return adminAxios.delete(`/admin/game-card-schedules/${id}`);
};

// Получить пользователей на конкретной игре
export const getSchedulePlayers = (scheduleId) =>
    adminAxios.get(`/admin/game-card-schedules/${scheduleId}/users`);

// Удалить запись пользователя (уменьшить count на 1)
export const removeSchedulePlayer = (scheduleId, userId) =>
    adminAxios.delete(`/admin/game-card-schedules/${scheduleId}/users/${userId}`);

// Добавить пользователя на игру
export const addSchedulePlayer = (scheduleId, { userId }) =>
    adminAxios.post(`/admin/game-card-schedules/${scheduleId}/add-user`, { userId });

// Поиск пользователей
export const searchUsers = (query) =>
    adminAxios.get(`/admin/users/search`, { params: { query } });

